module.exports = __webpack_public_path__ + "img/30.9fb0d6b0.jpg";